export default __webpack_public_path__ + "images/icon_192.png";